import { useState } from 'react';

import { FormControl, TextField } from '@mui/material';
import { useTranslate } from 'react-admin';

import { flowchartLogger } from 'src/lib/logger';

import NodeControlForm from '../NodeControlForm';

import type { NodeControlsProps } from '../../dataProvider/types';

export interface ForwardType extends Record<string, unknown> {
  number: string;
}

interface ForwardControlsProps extends NodeControlsProps {
  updateNodeData: (data: Record<string, unknown>) => void;
  data: ForwardType;
}

export default function ForwardControls({ updateNodeData, data }: ForwardControlsProps): React.ReactElement {
  const [number, setNumber] = useState<string>(data.number ?? '');
  const translate = useTranslate();

  const onForwardDataUpdate = (event: React.MouseEvent | React.FormEvent): void => {
    event.preventDefault();
    flowchartLogger.debug('ForwardControls: onForwardDataUpdate', { number });
    if (number === null) {
      flowchartLogger.debug('ForwardControls: number is null. Update cancelled.');
      return;
    }
    updateNodeData({ number });
  };
  return (
    <NodeControlForm onSubmit={onForwardDataUpdate} data={data} updateNodeData={updateNodeData}>
      <FormControl sx={{ display: 'flex', flexDirection: 'column' }} variant='outlined'>
        <TextField
          label={translate('callflows.nodes.forward.number')}
          value={number}
          onChange={(event) => {
            setNumber(event.target.value);
          }}
        />
      </FormControl>
    </NodeControlForm>
  );
}
